import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";

export class PostUser extends DataObject {
    _type = "post_user";

    id;
    post_id;
    user_id;
    created_at;
    updated_at;
    deleted_at;
}

export class PostUserMapperParameter extends Parameter {
    postUserMapper;
}

export class PostUserFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {PostUserMapperParameter} postUserMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the PostUser object with.
     * @returns {PostUser}
     */
    static construct(postUserMapperParameter, data = null) {
        if (data != null) {
            let postUser = DataObjectFactory.getInstance().construct(
                PostUser,
                data ? postUserMapperParameter.postUserMapper(data) : null
            );
            return postUser;
        }

        return null;
    }
}
